import { render, staticRenderFns } from "./ShareModalPersonality.vue?vue&type=template&id=5e80e9ae&"
import script from "./ShareModalPersonality.vue?vue&type=script&lang=js&"
export * from "./ShareModalPersonality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports